import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from 'sonner';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import UserProfileCard from './UserProfileCard';
import CurrentRequestCard from './CurrentRequestCard';
import TransferHistoryCard from './TransferHistoryCard';
import { EventHistoryCard } from './EventHistoryCard';
import { BehavioralPatternsCard } from './BehavioralPatternsCard';
import { AdminActionCard } from './AdminBehavior';

var userEmail;
var JSToken;
var accessToken;
if (localStorage.user) {
  userEmail = localStorage.user_email;
  JSToken = JSON.parse(localStorage.user);
  accessToken = JSToken.access_token;
}
const config = {
  headers: { Authorization: `Bearer ${accessToken}` },
};


const TransferRequestDetailPage = () => {
  const { requestId } = useParams(); 
  const navigate = useNavigate();
  const [delegateEmail, setDelegateEmail] = useState(null);
  const [requestData, setRequestData] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [deduction, setDeduction] = useState()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fetch initial request data to get delegate email
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [requestResponse, deductionResponse] = await Promise.all([
          axios.get(
            `https://dash.bestdiplomats.org/api/resource/Conference Transfer Request/${requestId}`,
            config
          ),
          axios.get(
            `https://dash.bestdiplomats.org/api/method/deduction_percentage_for_transfer_request?transfer_name=${requestId}`,
            config
          )
        ]);

      // Extract data
        const requestData = requestResponse.data.data;
        setDelegateEmail(requestData.delegate_email);
        setRequestData(requestData);

        const deductionData = deductionResponse.data.data;
        setDeduction(deductionData.deduction);
        console.log(deductionData.deduction)

      } catch (error) {
        console.error('Error fetching request data:', error);
      }
    };

    if (requestId) {
      fetchInitialData();
    }
  }, [requestId, refreshKey]);

  const handleUpdate = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleBack = () => {
    navigate(-1); 
  };

  if (!delegateEmail) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading request details...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" richColors />
      
      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <div className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="py-4 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <button
                  onClick={handleBack}
                  className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                >
                  <ArrowLeftIcon className="h-5 w-5" />
                  <span className="font-medium">Back</span>
                </button>
                <div className="h-8 w-px bg-gray-300"></div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">Transfer Request Review</h1>
                  <p className="text-sm text-gray-500">ID: {requestId}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 gap-6">
            {/* Left Column - Main Info */}
            <div className="lg:col-span-2 space-y-6">
              {/* User Profile */}
              <UserProfileCard key={`profile-${refreshKey}`} delegateEmail={delegateEmail} />

              {/* Current Request */}
              <CurrentRequestCard key={`current-${refreshKey}`} requestId={requestId} deduction={deduction}/>

              {/* Financial Summary */}
              {/* <FinancialSummaryCard key={`financial-${refreshKey}`} requestId={requestId} /> */}

              {/* Transfer History */}
              <TransferHistoryCard key={`history-${refreshKey}`} delegateEmail={delegateEmail} requestId={requestId} deduction={deduction}/>

              {/* Event History */}
              <EventHistoryCard key={`events-${refreshKey}`} delegateEmail={delegateEmail} />

              {/* Historical Financial */}
              {/* <HistoricalFinancialCard key={`hist-financial-${refreshKey}`} delegateEmail={delegateEmail} /> */}

              {/* Behavioral Patterns */}
              <BehavioralPatternsCard key={`behavioral-${refreshKey}`} delegateEmail={delegateEmail} />
            </div>

            {/* Right Column - Admin Actions */}
            <div className="lg:col-span-1">
              <AdminActionCard 
                key={`admin-${refreshKey}`}
                requestId={requestId} 
                requestData={requestData}
                deduction={deduction}
                onUpdate={handleUpdate}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransferRequestDetailPage;